document.addEventListener('teeinblue-event-after-cart-added', () => {
  setTimeout(() => {
    var request = new XMLHttpRequest();

    request.open('GET', '/cart.js', true);

    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        var data = JSON.parse(this.response);

        const drawer = document.querySelector('cart-notification');
        if (drawer) {
          fetch(window.location.pathname + "?sections=cart-notification-product,cart-notification-button,cart-icon-bubble")
            .then(res => res.json())
            .then(res => drawer.renderContents({
              key: data.items[0].key,
              sections: res
            }));
        }
      }
    };

    request.send();
  }, 1000)
});


document.addEventListener('teeinblue-event-component-injected', function () {
  if(window.innerWidth > 768) {
    setTimeout(() => {
      const SOURCE_SELECTOR = 'essential-estimated-delivery-app-embed';
      const TARGET_SELECTOR = '.essential-estimated-delivery-block-liquid';

      const moveElement = () => {
        const source = document.querySelector(SOURCE_SELECTOR);
        const target = document.querySelector(TARGET_SELECTOR);

        console.log(source,target)

        if (!source || !target) return false;

        if (target.nextElementSibling === source) return true;

        target.after(source);
        return true;
      };

      if (moveElement()) return;

      const observer = new MutationObserver(() => {
        if (moveElement()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      setTimeout(() => observer.disconnect(), 10000);
    }, 1000);
  }
});